// IMPORTS
import * as axios from "axios";

const store = require("store");
import jwt_decode from "jwt-decode";
const debug = require('debug')('auth-access')

// CONSTANTS
// auth token store path
const prefix = "widgetic";
const siteName = window.location.hostname; 
//
const authTokenStorePath = `${prefix}/${siteName}/authToken`;
// console.log("authTokenStorePath:", authTokenStorePath);
// debug("authTokenStorePath:", authTokenStorePath);
const authTokenEndPointPath = CONFIG.backendHost + "/account";
// console.log("auth token endpoint Path:", authTokenEndPointPath);
// debug("auth token endpoint Path:", authTokenEndPointPath);
// readAuthToken - generates new auth token
const readAuthToken = async () => {
  const wp = require('../shared/wpapi');
  const secret = await wp.getSecret();

  // console.log("readAuthToken:", siteName, secret)
  let res;
  try{
    res = await axios.post(authTokenEndPointPath, {
      siteName: siteName,
      password: secret,
    });
    // console.log('readAuthToken:', res.data);
    store.set(authTokenStorePath, res.data);
    return res.data;
  } catch (e) {
    console.log('readAuthToken error', e);
    return {};
  }
}

// get saved / new auth token or renew it
export const getAuthToken = async () => {
  
  // if there is no token then read it
  let token = store.get(authTokenStorePath);
  if (!token) {
    // console.log("auth token not found, initing ");
    token = readAuthToken();
  } 
  // if current will expire then renew it
  else {
    // console.log("found stored auth token:", token);

    // renew auth Token
    const decoded = jwt_decode(token.authToken);    
    // debug("refreshing token about to expire at:", decoded.exp);
    if (Date.now() / 1000 + 100 > decoded.exp) {
      token = readAuthToken();
      // console.log("renewed auth token:", token);
    }
  }

  return token;
};

// get access token for widgetic SDK
const accessTokenStorePath = `${prefix}/${siteName}/accessToken`;
// console.log("accessTokenStorePath:", accessTokenStorePath);
// debug("accessTokenStorePath:", accessTokenStorePath);
const acessTokenEndPointPath = CONFIG.backendHost + '/' + CONFIG.widgetId + '/install';
// console.log("acessTokenEndPointPath:", accessTokenStorePath);
// debug("acessTokenEndPointPath:", accessTokenStorePath);
export const getAccessToken = async (force = false) => {
  // console.log('getAccessToken force:', force);

  // read authToken first
  const authTokenRes = await getAuthToken();
  const authToken = authTokenRes.authToken;
  // console.log("on getAccessToken found authToken:", authToken);
  // debug("on getAccessToken found authToken:", authToken);
  if (!authToken) { throw new Error("no authtoken"); }

  // read stored access token
  const accessTokenStorage = store.get(accessTokenStorePath);
  const accessToken = accessTokenStorage ? accessTokenStorage[CONFIG.widgetId]  : null;
  // console.log("found accessToken", accessToken, force);
  // debug("found accessToken", accessToken);
  
  // renew access token if not found/expired or wanna force to set the premium status
  if (!accessToken || Date.now() / 1000 + 100 >= accessToken.expires || force) {
    try {
      const headers = { Authorization: `Bearer ${authToken}`};
      let res = await axios.post( acessTokenEndPointPath, {}, { headers } );
      // console.log("renewed access token:", res.data);
      store.set(accessTokenStorePath, { [CONFIG.widgetId]: res.data });
    } catch (e) {
      console.log('get access Token error:', e);
      return {};
    }
  }

  // return accessToken from store
  const d = store.get(accessTokenStorePath)[CONFIG.widgetId];
  // console.log('sending over from accessToken:', d);
  // debug('sending over from accessToken:', d);
  return d;
};

// check if a skin is a preset
const presetSkinRegex = /^p[1-9]{1}_/;
export const isPresetSkin = (skinId) => presetSkinRegex.test(skinId);
